import { RouteConfig } from 'vue-router';

const task: RouteConfig = {
  path: '/task',
  component: () => import('../views/task/task.vue'),
  meta: {
    title: '数据开发中心'
  },
  children: [
    {
      path: '/task/todo',
      meta: {
        title: '我的待办'
      },
      component: () => import('../views/task/pages/todo/todo.vue')
    },
    {
      path: '/task/done',
      meta: {
        title: '我的已办'
      },
      component: () => import('../views/task/pages/done/done.vue')
    },
    {
      path: '/task/message',
      meta: {
        title: '通知公告'
      },
      component: () => import('../views/task/pages/message/message.vue')
    },
    {
      path: '/task/dashboard',
      meta: {
        title: '预警仪表盘'
      },
      component: () => import('../views/task/pages/dashboard/dashboard.vue')
    },
    {
      path: '/task/full',
      meta: {
        title: '预警监督台'
      },
      component: () => import('../views/task/pages/full/full.vue')
    }
  ]
};

export default task;
